import { config, debug } from "aaa";
import * as NetworkStapler from "network/NetworkStapler";
import AuthStore from "stores/AuthStore";
import { IS_MASTER } from "config";

class APIClient {
    apiClient: NetworkStapler.APIClient;

    constructor(baseUrl: string, options?: { languageHeaders?: boolean, authToken?: string, cache?: RequestCache, noAuth?: boolean, noContentType?: boolean }) {
        this.apiClient = new NetworkStapler.APIClient({
            baseUrl: baseUrl,
            injectHeaders: (target => {
                let addContentType = true;
                if (target.headers) {
                    addContentType = target.headers["Content-Type"] ? false : true;
                }

                const ret = {
                    ...target.headers,
                    ...options?.noAuth ? {} : { "Authorization": `Bearer ${options?.authToken ?? AuthStore.accessToken}` },
                    ...options?.noContentType ? {} : { "Content-Type": addContentType ? "application/json" : target.headers!["Content-Type"] },
                };

                const hideLanguageHeaders = options?.languageHeaders === false;
                if (!hideLanguageHeaders) {
                    ret["Accept-Language"] = AuthStore.locale;
                    ret["Client-Accept-Language"] = AuthStore.locale;
                }

                return ret;
            }),
            throwOnErrorStatusCodes: true,
            cache: options?.cache,
        });
    }

    request(target: NetworkStapler.IAPITarget): Promise<Response> {
        return this.apiClient.request(target).catch(this.checkStatusCodeError);
    }

    requestJSON(target: NetworkStapler.IAPITarget): Promise<object> {
        return this.apiClient.requestJSON(target).catch(this.checkStatusCodeError);
    }

    requestType<T>(target: NetworkStapler.ITypedAPITarget<T>): Promise<T> {
        return this.apiClient.requestType(target).catch(this.checkStatusCodeError);
    }

    requestBlob(target: NetworkStapler.IAPITarget): Promise<Blob> {
        return this.apiClient.requestBlob(target).catch(this.checkStatusCodeError);
    }

    checkStatusCodeError(error: any): any {
        let handled = false;
        if (error instanceof NetworkStapler.APIClientStatusCodeError) {
            if (error.statusCode) {
                debug.log("### APIClient.checkStatusCodeError()", error.statusCode);
                switch (error.statusCode) {
                    case 401:
                        debug.log("### APIClient.checkStatusCodeError() 401 unauthorized");
                        AuthStore.unauthorized();
                        handled = true;

                        break;
                    case 403:
                        debug.log("### APIClient.checkStatusCodeError() 403 forbidden");
                        AuthStore.forbidden();
                        handled = true;
                        break;
                    default:
                        break;
                }
            }
        } else {
            debug.log("### APIClient.checkStatusCodeError() network error:", error);
        }

        if (!handled) {
            throw error;
        }
    }
}

// presto api base url
export const NetbankingAPIClient = new APIClient(config.network.baseUrl);

// george business api base url
export const GeorgeBusinessAPIClient = new APIClient(config.network.georgeBusinessBaseUrl);

// fix 304 in native APP which doesn't seem to handle this specific code or caching correctly
export const NetbankingAPIClientNoCache = new APIClient(config.network.baseUrl, { cache: "no-store" });

// messaging api
export const MessagingAPIClient = new APIClient(config.network.messagingBaseUrl);

// card api
export const CardAPIClient = new APIClient(config.network.cardBaseUrl);

// account api
export const AccountAPIClient = new APIClient(config.network.accountBaseUrl);

// login api
export const LoginAPIClient = new APIClient(config.network.loginBaseUrl, { languageHeaders: false });

// no baseUrl
export const GenericAPIClient = new APIClient(config.network.genericBaseUrl);

export const GenericAPIClientWithoutContentType = new APIClient(config.network.genericBaseUrl, { noContentType: true });


// Now for testing use direct API
// export const OptioPayAPIClient = new APIClient("https://docs.gpp.ag/v1/users/hybrid-test", { authToken: "VALID_TOKEN" });
export const OptioPayAPIClient = new APIClient(
    `${config.network.baseUrl}${IS_MASTER
        ? "/proxy/gpe/proxy/db7cc516-ec41-4391-aaf1-6eb848382cf7"
        : "/proxy/gpe/proxy/951b1627-5306-486f-8828-70d747050f1c"
    }`);

// advisorservices api
export const AdvisorServicesAPIClient = new APIClient(config.network.adivsorServicesBaseUrl);

export const LuxAPIClient = new APIClient(config.network.luxBaseUrl, { noAuth: true });


// ecos api base url
export const EcosAPIClient = new APIClient(config.network.ecosBaseUrl, { languageHeaders: false });


// WEBPACK FOOTER //
// ./src/network/APIClient.ts